define('app/models/CompoundFilter',['require','glu/model','app/config/filterTypes','glu/util'],function(require) {
	'use strict';

	var Model = require('glu/model'),
		FILTER_TYPES = require('app/config/filterTypes'),
		_ = require('glu/util');


	var VALID_OPERATORS = _.pluck(FILTER_TYPES.compound, 'operator');

	return Model.extend({

		initialize: function() {
			var self = this;

			this.listenTo(this, 'change', function() {
				this.set('isDirty', true, {
					silent: true
				});
			});

			window.setTimeout(function() {
				self.addEventHandlers();
			}, 2000);
		},

		addEventHandlers: function() {
			var self = this;

			self.listenTo(self.filterCollection(), 'add remove change', function() {
				self.trigger('change');
			});
		},

		validate: function() {

			if (VALID_OPERATORS.indexOf(this.get('operator')) === -1) {
				return 'Invalid operator: ' + this.get('operator');
			}

			var hasInvalidChildren = this.filterCollection().any(function(filter) {
				return !filter.isValid();
			});

			if (hasInvalidChildren) {
				return 'One or more child filters is invalid';
			}

		},
		setOperator: function(operator) {
			this.set('operator', operator);
		},
		getOperator: function() {
			return this.get('operator');
		},

		filterCollection: function() {
			return this.get('filterCollection');
		},

		isCompound: function() {
			return true;
		},

		isEmpty: function() {
			return this.filterCollection().length === 0;
		},

		addFilter: function(filter) {
			if (!this.isDuplicate(filter)) {
				this.filterCollection().push(filter);
			}
		},

		replaceFilter: function(filter) {
			_.each(this.filterCollection().models, function(d) {
				if ((d.get('fieldObject') && (d.get('fieldObject').get('id') === filter.get('fieldObject').get('id'))) ||
					(d.get('segmentId') && (d.get('segmentId') === filter.get('fieldObject').get('id')))) {
					d.remove();
				}
			});
			this.filterCollection().push(filter);
		},

		isDuplicate: function(filter) {
			var count = 0;

			_.each(this.filterCollection().models, function(d) {
				if ((d.get('fieldObject') && d.get('fieldObject').get('id') === filter.get('fieldObject').get('id')) ||
					(d.get('segmentId') && d.get('segmentId') === filter.get('fieldObject').get('id'))) {
					count++;
				}
			});

			return count > 0;
		},

		isDirty: function() {
			return !!this.get('isDirty');
		},

		clean: function() {
			this.set('isDirty', false, {
				silent: true
			});
			this.filterCollection().each(function(filter) {
				if (filter.clean) {
					filter.clean();
				}
			});
		},

		toJSON: function() {
			var segments = [];
			var segmentFilters = [];
			var filters;

			var segmentExists = function(segment) {
				return _.find(segments, function(s) {
					return segment.get('segmentId') ? s === segment.get('segmentId') : false;
				});
			};

			var segmentFilterExists = function(segment) {
				return _.find(segmentFilters, function(s) {
					return segment.get('fieldObject').id ? s.segmentId === segment.get('fieldObject').id : false;
				});
			};

			// build a list of filters to serialize into a report request.
			// remove any filters that are improperly configured.
			if (this.filterCollection() && this.filterCollection().models) {
				var validFilters = _.reject(this.filterCollection().models, function(filter) {
					if (filter.get('columnType') === 'SEGMENT' || filter.get('segmentId')) {

						// Segment
						if (filter.get('segmentId') && !segmentExists(filter)) {
							segments.push(filter.get('segmentId'));
						}

						// Segment as filter
						if (filter.get('columnType') === 'SEGMENT' && !segmentFilterExists(filter)) {
							segmentFilters.push({
								segmentId: filter.get('fieldObject').id,
								val: filter.get('values')[0]
							});
						}

						// Reject all segments (added separately)
						return true;
					} else {
						return filter.validate ? filter.validate() : filter;
					}
				});

				filters = validFilters.map(function(filter) {
					return filter.toJSON ? filter.toJSON() : filter;
				});

				// Add segments to filter collection
				if (segments.length > 0) {
					for (var i = 0; i < segments.length; i++) {
						var x = {
							operator: 'HAS',
							operands: [{
								segmentId: segments[i]
							}]
						};

						filters.push(x);
					}
				}

				// Add segment filters to filter collection
				if (segmentFilters.length > 0) {
					for (var j = 0; j < segmentFilters.length; j++) {
						var z = {
							operator: 'EQ',
							operands: [{
								segmentId: segmentFilters[j].segmentId
							}, {
								val: segmentFilters[j].val
							}]
						};

						filters.push(z);
					}
				}

				return {
					operator: this.get('operator'),
					operands: filters
				};
			}
		},

		substitute: function(replacementFilter) {
			this.substitutedFilters = this.filterCollection().filter(function(f) {
				return f && f.fieldId && f.fieldId() === replacementFilter.fieldId();
			});

			for (var i = this.substitutedFilters.length; i-- > 0; void 0) {
				this.substitutedFilters[i].remove();
			}

			this.filterCollection().push(replacementFilter);
			this.replacementFilter = replacementFilter;
		},

		unsubstitute: function() {
			this.filterCollection().remove(this.replacementFilter);
			this.filterCollection().add(this.substitutedFilters);
		},

		clone: function() {
			var attributes = _.clone(this.attributes);
			var filters = this.attributes.filterCollection;
			attributes.filterCollection = new filters.constructor(_.map(filters.models, function(m) {
				return m.clone();
			}));
			return new this.constructor(attributes);
		}
	});

});

